export default theme => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
    stepper: {
      backgroundColor: theme.palette.background.default,
    },
    stepperContainer: {
      width: '70%',
      alignSelf: 'center',
    }
  });
  